// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__mpfM-","box":"Overlay_box__4i-6U","title":"Overlay_title__jGZGL","element":"Overlay_element__7b3qe"};